import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { SnapshotStatus } from '../../Models/enums/snapshotStatus';
import { ProductService } from '../../Services/product/product.service';

@Component({
  selector: 'ngx-launch-dialog',
  templateUrl: './launch-dialog.component.html',
  styleUrls: ['./launch-dialog.component.scss']
})
export class LaunchDialogComponent implements OnInit {
  @Input() snapshots: any;
  @Input() service: any;

  selectedComment: string | null = null;

  startServiceForm = new FormGroup({
    // product: new FormControl('', Validators.required),
    snapshot: new FormControl('', Validators.required),
  });

  constructor(protected ref: NbDialogRef<LaunchDialogComponent>) { }

  ngOnInit(): void {
    if(!this.snapshots.length){
      this.snapshots = undefined
    }

    this.startServiceForm.get('snapshot')?.valueChanges.subscribe(snapshotId => {
      const selectedSnapshot = this.snapshots?.find((item: any) => item.snapshot_id === snapshotId);
      this.selectedComment = selectedSnapshot?.comment || null;
    });

  }

  submit() {
    this.ref.close(this.startServiceForm.value);
  }

  cancel() {
    this.ref.close();
  }

}
